module.exports = __webpack_public_path__ + "static/media/taffiethule12.5dc54425.jpg";